import { Box, BoxProps, Stack, Typography } from '@mui/material';
import { ImageSizes } from '@sage/ui-components';

import Person from 'src/components/fragments/Person';
import { CompanyPhone, StaffMember } from 'src/store/sageAdminApi';
import { formatPhoneNumber } from 'src/utils/formUtils';

interface CompanyPhoneDetailsProps {
    containerProps?: BoxProps;
    companyPhone: CompanyPhone;
    staffMember?: StaffMember;
    displayNameColor?: string;
    hideAvatar?: boolean;
}

function CompanyPhoneDetails(props: CompanyPhoneDetailsProps) {
    const {
        containerProps,
        companyPhone,
        displayNameColor = 'common.black',
        staffMember,
        hideAvatar = false,
    } = props;

    const companyPhoneNumber =
        (companyPhone?.phoneNumber && formatPhoneNumber(companyPhone?.phoneNumber)) || '';

    return (
        <Box {...containerProps}>
            <Stack sx={{ gap: 0.5 }}>
                <Typography
                    variant="body2"
                    sx={{
                        color: displayNameColor,
                        fontWeight: 'bold',
                    }}
                >
                    {companyPhone.displayName}
                </Typography>
                {companyPhoneNumber && (
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'grey.500',
                            fontWeight: 'bold',
                        }}
                    >
                        {companyPhoneNumber}
                    </Typography>
                )}
            </Stack>
            {staffMember && (
                <Stack
                    direction="row"
                    sx={{
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 1,
                    }}
                >
                    <Typography
                        variant="body2"
                        component="span"
                        sx={{
                            color: 'grey.700',
                        }}
                    >
                        Currently used by{' '}
                        <b>
                            {staffMember.firstName}{' '}
                            {staffMember.lastName ? `${staffMember?.lastName[0]}.` : ''}
                        </b>
                    </Typography>
                    {!hideAvatar && (
                        <Person
                            id={staffMember.id}
                            firstName={staffMember.firstName}
                            lastName={staffMember.lastName}
                            size={ImageSizes.XSmall}
                        />
                    )}
                </Stack>
            )}
        </Box>
    );
}

export default CompanyPhoneDetails;
